import KeywordsSet from './KeywordsSet'

export default KeywordsSet
